module.exports = __webpack_public_path__ + "img/img_slide_3.4c1af5b4.webp";